import { useEffect, useState } from "react"
import Recipes, { IRecipe } from "../../shared/Recipes"
import EmptyRecipe from "../EmptyRecipe"
import Loading from "../../libs/loading/Loading"
import RecipeCache from "../../data/RecipeCache"
import GTable from "../../libs/gtable/GTable"

import Usernames from "../../libs/login/Usernames"
import Utils from "../../libs/Utils"
import { useDialog } from "../../libs/dialog/DialogProvider"
import RecipeDlg from "./RecipeDlg"

function _username(props:{userId:string}) {
    const [name,setName] = useState<string>("")
    useEffect(() => {
        Usernames.i.get(props.userId).then(name => setName(name))
    },[props.userId])
    return <div>{name ? name : <Loading/>}</div>
}

function _list(props:{recipes:IRecipe[]}){
    const list = props.recipes
    const {openDialog} = useDialog()

    const cell = (row:IRecipe, col:string, _:any) => {
        switch(col){
        case "Recipe":      return <div className="name"><div className="w700">{row.name}</div><div className="small-text">{row.description}</div></div>
        case "Author":      return <_username userId={row.user}/>
        case "Created":     return <div className="date">{Utils.formatDate("yyyy-MM-dd", new Date(row.created))}</div>
        default:            return ""
        }
    }
    const onView = (row:IRecipe) => () => openDialog({id:"recipe",transition:"slideUp",canClose:()=>false,children:<RecipeDlg recipe={row}/>})
    const rowProp = (row:IRecipe) => ({onClick:onView(row)})
    return <div className="recipeList">
        <GTable rows={list} cols={["Recipe", "Author", "Created"]} rowKey={row => row._id} bodyCell={cell} bodyRowProps={rowProp} tableName={"recipes"}/>
    </div>
}
export default function RecipeList(){
    const [recipes,setRecipes] = useState<IRecipe[]|null>(null)
    const onUpdate = (_:string,recipes:Recipes) => setRecipes([...recipes.items])
    useEffect(() => {
        RecipeCache.i.getRecipes().then(recipes => setRecipes([...recipes.items]))
        RecipeCache.i.on("update", onUpdate)
        return () => {RecipeCache.i.removeListener("update", onUpdate)}
    },[])
    const list = recipes ? (recipes.length==0 ? <EmptyRecipe/> : <_list recipes={recipes}/>) : <Loading className="mt-32"/>
    return <div id="recipes">
        {list}
    </div>
}